function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  transform: translate3d(0, 0, 0);\n\n  padding: 0 15px;\n  ",
        " {\n    padding: 0 100px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: ",
        ";\n  left: 0;\n  transition: top 0.2s;\n  height: ",
        ";\n  width: 100%;\n  z-index: 20;\n  background: linear-gradient(268.35deg, rgba(238, 240, 250, 0.02) 37.9%, rgba(228, 230, 245, 0) 99.91%);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n  boxshad: none;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState, useContext } from "react";
import throttle from "lodash/throttle";
import { useWeb3React } from "@web3-react/core";
import styled, { useTheme } from "styled-components";
import BottomNav from "../../components/BottomNav";
import { Box } from "../../components/Box";
import { Link } from "../../components/Link";
import { Button } from "../../components/Button";
import Flex from "../../components/Box/Flex";
import { SwychLogo } from "../../components/Svg";
import MenuItems from "../../components/MenuItems/MenuItems";
import { SubMenuItems } from "../../components/SubMenuItems";
import { useMatchBreakpoints } from "../../hooks";
import { Context } from "../Modal/ModalContext";
import CakePrice from "../../components/CakePrice/CakePrice";
import { MENU_HEIGHT, TOP_BANNER_HEIGHT, TOP_BANNER_HEIGHT_MOBILE } from "./config";
import { MenuContext } from "./context";
var Wrapper = styled.div.withConfig({
    componentId: "sc-5b31cf0f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.topMenuBackground;
});
var StyledNav = styled.nav.withConfig({
    componentId: "sc-5b31cf0f-1"
})(_templateObject1(), MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FixedContainer = styled.div.withConfig({
    componentId: "sc-5b31cf0f-2"
})(_templateObject2(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? 0 : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var TopBannerContainer = styled.div.withConfig({
    componentId: "sc-5b31cf0f-3"
})(_templateObject3(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-5b31cf0f-4"
})(_templateObject4());
var Inner = styled.div.withConfig({
    componentId: "sc-5b31cf0f-5"
})(_templateObject5());
var StyledBox = styled(Box).withConfig({
    componentId: "sc-5b31cf0f-6"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.topMenuBackground;
});
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, userMenu = param.userMenu, banner = param.banner, globalMenu = param.globalMenu, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, bnbPriceUsd = param.bnbPriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children;
    var account = useWeb3React().account;
    var ref = useMatchBreakpoints(), isMobile = ref.isMobile, isMd = ref.isMd;
    var ref1 = useState(true), showMenu = ref1[0], setShowMenu = ref1[1];
    var isOpen = useContext(Context).isOpen;
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    var topBannerHeight = isMobile ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT;
    var totalTopMenuHeight = banner ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT;
    var theme = useTheme();
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            // Always show the menu when user reach the top
            if (isTopOfPage) {
                setShowMenu(true);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    // Has scroll up
                    setShowMenu(true);
                } else {
                    // Has scroll down
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight
    ]);
    // Find the home link if provided
    // const homeLink = links.find((link) => link.label === "Home");
    var subLinksWithoutMobile = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return !subLink.isMobileOnly;
    });
    var subLinksMobileOnly = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return subLink.isMobileOnly;
    });
    var ref2 = useState(false), showSubmenu = ref2[0], setShowSubmenu = ref2[1];
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            isModalOpen: isOpen,
            children: [
                /*#__PURE__*/ _jsxs(FixedContainer, {
                    showMenu: showMenu,
                    height: totalTopMenuHeight,
                    style: {
                        position: "relative"
                    },
                    children: [
                        banner && /*#__PURE__*/ _jsx(TopBannerContainer, {
                            height: topBannerHeight,
                            children: banner
                        }),
                        /*#__PURE__*/ _jsxs(StyledNav, {
                            children: [
                                /*#__PURE__*/ _jsxs(Flex, {
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: "/swap",
                                            children: /*#__PURE__*/ _jsx(SwychLogo, {
                                                isMobile: isMobile || isMd,
                                                isDark: isDark,
                                                width: "125px",
                                                height: "30px"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            style: {
                                                marginTop: 20,
                                                marginLeft: 32,
                                                display: isMobile || isMd ? "none" : ""
                                            },
                                            children: /*#__PURE__*/ _jsx("svg", {
                                                width: "1",
                                                height: "20",
                                                viewBox: "0 0 1 20",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ _jsx("rect", {
                                                    width: "1",
                                                    height: "20",
                                                    rx: "0.5",
                                                    fill: "#B4BAC7"
                                                })
                                            })
                                        }),
                                        !isMobile && /*#__PURE__*/ _jsx(MenuItems, {
                                            items: links,
                                            activeItem: activeItem,
                                            activeSubItem: activeSubItem,
                                            ml: "24px"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Flex, {
                                    style: {
                                        gap: "20px"
                                    },
                                    alignItems: "center",
                                    height: "100%",
                                    children: [
                                        !isMobile && !isMd && /*#__PURE__*/ _jsx(Box, {
                                            mr: "12px",
                                            children: /*#__PURE__*/ _jsx(CakePrice, {
                                                showSkeleton: false,
                                                cakePriceUsd: cakePriceUsd
                                            })
                                        }),
                                        /*#__PURE__*/ _jsxs(Flex, {
                                            style: {
                                                position: "relative"
                                            },
                                            alignItems: "center",
                                            onMouseLeave: function() {
                                                return setShowSubmenu(false);
                                            },
                                            children: [
                                                showSubmenu && /*#__PURE__*/ _jsxs(StyledBox, {
                                                    style: {
                                                        borderRadius: 16,
                                                        marginTop: 270,
                                                        marginRight: -50,
                                                        padding: 24,
                                                        paddingRight: 60,
                                                        boxShadow: "12px 32px 35px rgba(15, 20, 30, 0.25)"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            target: "_blank",
                                                            href: "https://docs.swych.finance/",
                                                            fontSize: "12px",
                                                            color: "secondary",
                                                            style: {
                                                                marginBottom: 16,
                                                                color: theme.colors.hardTextColor
                                                            },
                                                            children: [
                                                                "Documentation",
                                                                /*#__PURE__*/ _jsxs("svg", {
                                                                    style: {
                                                                        marginLeft: 6
                                                                    },
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 6 6",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M1 5.18713L5.12479 1.06234",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M5.12479 5.18717V1.06238H1",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            target: "_blank",
                                                            href: "https://docs.swych.finance/",
                                                            fontSize: "12px",
                                                            color: "secondary",
                                                            style: {
                                                                marginBottom: 16,
                                                                color: theme.colors.hardTextColor
                                                            },
                                                            children: [
                                                                "Help center",
                                                                /*#__PURE__*/ _jsxs("svg", {
                                                                    style: {
                                                                        marginLeft: 6
                                                                    },
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 6 6",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M1 5.18713L5.12479 1.06234",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M5.12479 5.18717V1.06238H1",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            target: "_blank",
                                                            href: "https://docs.swych.finance/",
                                                            fontSize: "12px",
                                                            color: "secondary",
                                                            style: {
                                                                marginBottom: 16,
                                                                color: theme.colors.hardTextColor
                                                            },
                                                            children: [
                                                                "FAQ",
                                                                /*#__PURE__*/ _jsxs("svg", {
                                                                    style: {
                                                                        marginLeft: 6
                                                                    },
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 6 6",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M1 5.18713L5.12479 1.06234",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M5.12479 5.18717V1.06238H1",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Link, {
                                                            target: "_blank",
                                                            href: "https://docs.swych.finance/",
                                                            fontSize: "12px",
                                                            color: "secondary",
                                                            style: {
                                                                marginBottom: 16,
                                                                color: theme.colors.hardTextColor
                                                            },
                                                            children: [
                                                                "Contact",
                                                                /*#__PURE__*/ _jsxs("svg", {
                                                                    style: {
                                                                        marginLeft: 6
                                                                    },
                                                                    width: "10",
                                                                    height: "10",
                                                                    viewBox: "0 0 6 6",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M1 5.18713L5.12479 1.06234",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("path", {
                                                                            d: "M5.12479 5.18717V1.06238H1",
                                                                            stroke: theme.colors.hardTextColor,
                                                                            strokeWidth: "0.6",
                                                                            strokeLinecap: "round",
                                                                            strokeLinejoin: "round"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Flex, {
                                                            style: {
                                                                marginTop: 32,
                                                                gap: 24
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Link, {
                                                                    target: "_blank",
                                                                    href: "https://twitter.com/SwychFinance",
                                                                    children: /*#__PURE__*/ _jsx("svg", {
                                                                        width: "24",
                                                                        height: "20",
                                                                        viewBox: "0 0 15 12",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ _jsx("path", {
                                                                            d: "M14.955 1.34849C14.4393 1.57725 13.885 1.73179 13.3033 1.80132C13.897 1.44542 14.3531 0.88184 14.5678 0.21026C14.012 0.53989 13.3966 0.77916 12.7415 0.90812C12.217 0.34918 11.4695 0 10.6424 0C9.0542 0 7.7665 1.28758 7.7665 2.87576C7.7665 3.10117 7.7919 3.32068 7.841 3.53116C5.45084 3.41124 3.33181 2.26628 1.91338 0.52636C1.66583 0.95109 1.52397 1.44507 1.52397 1.97213C1.52397 2.96989 2.03168 3.85012 2.80335 4.3658C2.33194 4.3509 1.8885 4.2215 1.50077 4.0061C1.50044 4.0181 1.50044 4.0302 1.50044 4.0423C1.50044 5.4356 2.49176 6.5979 3.80738 6.8623C3.56607 6.928 3.312 6.9631 3.04973 6.9631C2.86442 6.9631 2.6843 6.9451 2.50866 6.9116C2.87465 8.054 3.93669 8.8855 5.19518 8.9086C4.21094 9.68 2.97095 10.1398 1.62352 10.1398C1.39139 10.1398 1.16248 10.1261 0.9375 10.0996C2.21022 10.9156 3.72187 11.3917 5.34594 11.3917C10.6357 11.3917 13.5284 7.0096 13.5284 3.20917C13.5284 3.08449 13.5256 2.9605 13.52 2.83708C14.0819 2.43169 14.5694 1.92524 14.955 1.34849Z",
                                                                            fill: "#98A1C0"
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx(Link, {
                                                                    target: "_blank",
                                                                    href: "https://discord.gg/hgyWpZuMsx",
                                                                    children: /*#__PURE__*/ _jsx("svg", {
                                                                        width: "24",
                                                                        height: "20",
                                                                        viewBox: "0 0 16 12",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        children: /*#__PURE__*/ _jsx("path", {
                                                                            d: "M13.0325 0.95914C12.0748 0.51107 11.0508 0.18542 9.9802 0C9.84869 0.23771 9.6951 0.55743 9.5892 0.81177C8.4512 0.64062 7.3236 0.64062 6.2065 0.81177C6.1006 0.55743 5.94354 0.23771 5.81089 0C4.73916 0.18542 3.71399 0.51226 2.7563 0.96152C0.824646 3.8805 0.301006 6.727 0.562826 9.5331C1.844 10.4898 3.08562 11.071 4.30628 11.4513C4.60767 11.0365 4.87646 10.5956 5.10803 10.1309C4.66701 9.9633 4.24461 9.7565 3.84549 9.5164C3.95137 9.438 4.05494 9.356 4.15501 9.2716C6.5894 10.4102 9.23429 10.4102 11.6396 9.2716C11.7408 9.356 11.8444 9.438 11.9491 9.5164C11.5488 9.7577 11.1253 9.9645 10.6842 10.1321C10.9158 10.5956 11.1834 11.0377 11.486 11.4525C12.7078 11.0722 13.9506 10.491 15.2318 9.5331C15.539 6.2801 14.707 3.45977 13.0325 0.95914ZM5.43967 7.8074C4.70891 7.8074 4.10962 7.1251 4.10962 6.2944C4.10962 5.4636 4.69611 4.7802 5.43967 4.7802C6.1833 4.7802 6.7825 5.4624 6.7697 6.2944C6.7709 7.1251 6.1833 7.8074 5.43967 7.8074ZM10.3549 7.8074C9.6242 7.8074 9.0249 7.1251 9.0249 6.2944C9.0249 5.4636 9.6113 4.7802 10.3549 4.7802C11.0985 4.7802 11.6978 5.4624 11.685 6.2944C11.685 7.1251 11.0985 7.8074 10.3549 7.8074Z",
                                                                            fill: "#98A1C0"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    style: {
                                                        background: "transparent",
                                                        boxShadow: "none"
                                                    },
                                                    onMouseEnter: function() {
                                                        return setShowSubmenu(true);
                                                    },
                                                    children: /*#__PURE__*/ _jsxs("svg", {
                                                        width: "18",
                                                        height: "4",
                                                        viewBox: "0 0 18 4",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M8.99995 3.00005C9.55231 3.00005 10 2.55233 10 1.99997C10 1.44771 9.55231 1 8.99995 1C8.44771 1 8 1.44771 8 1.99997C8 2.55233 8.44771 3.00005 8.99995 3.00005Z",
                                                                stroke: theme.colors.hardTextColor,
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M16.0001 3.00005C16.5523 3.00005 17 2.55233 17 1.99997C17 1.44771 16.5523 1 16.0001 1C15.4477 1 15 1.44771 15 1.99997C15 2.55233 15.4477 3.00005 16.0001 3.00005Z",
                                                                stroke: theme.colors.hardTextColor,
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            }),
                                                            /*#__PURE__*/ _jsx("path", {
                                                                d: "M2.00001 3.00005C2.55228 3.00005 3 2.55233 3 1.99997C3 1.44771 2.55228 1 2.00001 1C1.44772 1 1 1.44771 1 1.99997C1 2.55233 1.44772 3.00005 2.00001 3.00005Z",
                                                                stroke: theme.colors.hardTextColor,
                                                                strokeWidth: "1.8",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        userMenu
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                subLinks && /*#__PURE__*/ _jsxs(Flex, {
                    justifyContent: "space-around",
                    children: [
                        /*#__PURE__*/ _jsx(SubMenuItems, {
                            items: subLinksWithoutMobile,
                            mt: "".concat(totalTopMenuHeight + 1, "px"),
                            activeItem: activeSubItem
                        }),
                        (subLinksMobileOnly === null || subLinksMobileOnly === void 0 ? void 0 : subLinksMobileOnly.length) > 0 && /*#__PURE__*/ _jsx(SubMenuItems, {
                            items: subLinksMobileOnly,
                            mt: "".concat(totalTopMenuHeight + 1, "px"),
                            activeItem: activeSubItem,
                            isMobileOnly: true
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(BodyWrapper, {
                    children: /*#__PURE__*/ _jsx(Inner, {
                        isPushed: false,
                        showMenu: showMenu,
                        children: children
                    })
                }),
                isMobile && /*#__PURE__*/ _jsx(BottomNav, {
                    items: links,
                    activeItem: activeItem,
                    activeSubItem: activeSubItem
                })
            ]
        })
    });
};
export default Menu;
